import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function TopRevenueClients({ table_data }) {
  const [labels, setLabels] = useState([]);
  const [revenue, setRevenue] = useState([]);
  const [options, setOptions] = useState({});
  const [data, setData] = useState({});
  const [colors, setColors] = useState([]);
  let userLoging = {};
  let currencies = [];
  userLoging = JSON.parse(localStorage.getItem("user") || "{}");
  currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
  const defaultCurrencyId = Number(userLoging?.default_currency_id || 1);
  const selectedCurrency = currencies.find(
  (currency) =>
    Number(currency.value) === defaultCurrencyId
);
  const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
  const currencyType = defaultCurrencyId === 1 ? "en-IN" : "en-US";
  const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "K";
  const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000;

  useEffect(() => {
    let Labels = [];
    let Revenue = [];
    let color = [];

    let mid_revenue =
      table_data?.reduce((sum, item) => sum + item.current_revenue, 0) /
      table_data?.length;

    table_data?.forEach((item) => {
      const revCr = item.current_revenue / amountDivisor;
      const mid_range = mid_revenue / amountDivisor;
      Labels.push(item.name);
      Revenue.push(revCr.toFixed(2));

      if (revCr >= mid_range) color.push("#34c759"); // red
      else if (revCr < mid_range) color.push("#ff9500"); // orange
      else color.push("#1b80f4"); // default fallback
    });

    setLabels(Labels);
    setRevenue(Revenue);
    setColors(color);
  }, [table_data]);

  useEffect(() => {
    setData({
      labels,
      datasets: [
        {
          label: "Revenue",
          data: revenue,
          backgroundColor: colors,
          borderRadius: 5,
          barThickness: 30,

          // ⭐ Working spacing controls
          categoryPercentage: 0.6, // reduce bar width → more gap
          barPercentage: 0.8,
        },
      ],
    });

    setOptions({
      indexAxis: "y",
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        datalabels: { display: false },
        tooltip: {
          callbacks: {
            label: (context) => `₹ ${context.raw} ${amountSuffix}`,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            callback: (value) => `₹ ${value} ${amountSuffix}`,
          },
        },
        y: {
          ticks: { font: { size: 12 } },
        },
      },
    });
  }, [labels, revenue, colors]);

  return (
    <div style={{ width: "100%", height: "400px", margin: "auto" }}>
      {data?.datasets?.length > 0 && <Bar data={data} options={options} />}
    </div>
  );
}

export default TopRevenueClients;
